import store from "../../configureStore";


export const UPDATE_RAW_DATA = "UPDATE_RAW_DATA";

export const updateRawData = (data) => store.dispatch({ type: UPDATE_RAW_DATA, ...data })

export const clearRawData=()=>store.dispatch({type:'CLEAR_RAW_DATA'})